const WISHLIST_KEY = 'millionYearsWishlist';

const getWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  } catch (_error) {
    return [];
  }
};

const setWishlist = (items) => {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
};

const updateButtonState = (button, saved) => {
  button.classList.toggle('is-saved', saved);
  button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  button.querySelector('[data-wishlist-label]').textContent = saved ? 'Saved for later' : 'Save for later';
};

const initialiseWishlistButton = (button) => {
  const productId = button.dataset.productId;
  if (!productId) return;

  const wishlist = getWishlist();
  updateButtonState(button, wishlist.some((item) => item.id === productId));

  button.addEventListener('click', () => {
    const currentWishlist = getWishlist();
    const existingIndex = currentWishlist.findIndex((item) => item.id === productId);

    if (existingIndex >= 0) {
      currentWishlist.splice(existingIndex, 1);
      setWishlist(currentWishlist);
      updateButtonState(button, false);
      return;
    }

    currentWishlist.unshift({
      id: productId,
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || window.location.pathname,
      image: button.dataset.productImage || '',
      savedAt: new Date().toISOString(),
    });
    setWishlist(currentWishlist);
    updateButtonState(button, true);
  });
};

document.querySelectorAll('[data-wishlist-button]').forEach(initialiseWishlistButton);
